import React from 'react';
import { DatabaseIcon, MailIcon, PhoneIcon, CheckCircleIcon } from 'lucide-react';
export function EnrichmentPricing() {
  return <section className="py-24 bg-slate-50" data-id="element-4415">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4416">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-4417">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-4418">
            Simple pricing for local business data{' '}
            <span className="text-blue-600" data-id="element-4419">enrichment</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-4420">
            Enrich local business contacts without enterprise contracts or
            hidden fees.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-4421">
          {/* Enrich Records */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-4422">
            <div className="flex items-center gap-3 mb-4" data-id="element-4423">
              <DatabaseIcon className="w-5 h-5 text-slate-400" data-id="element-4424" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-4425">
                Enrich local business records
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-4426">
              Match and enrich basic local business data with full profiles.
            </p>
            <div data-id="element-4427">
              <div className="flex items-baseline gap-2" data-id="element-4428">
                <span className="text-4xl font-bold text-slate-900" data-id="element-4429">Free</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-4430">
                unlimited company enrichments
              </p>
            </div>
          </div>

          {/* Owner Emails */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-4431">
            <div className="flex items-center gap-3 mb-4" data-id="element-4432">
              <MailIcon className="w-5 h-5 text-slate-400" data-id="element-4433" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-4434">
                Local business owner emails
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-4435">
              Find verified email addresses for local business decision-makers.
            </p>
            <div data-id="element-4436">
              <div className="flex items-baseline gap-2" data-id="element-4437">
                <span className="text-4xl font-bold text-slate-900" data-id="element-4438">$6</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-4439">
                per 100 emails found
              </p>
            </div>
          </div>

          {/* Employee Phones */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-4440">
            <div className="flex items-center gap-3 mb-4" data-id="element-4441">
              <PhoneIcon className="w-5 h-5 text-slate-400" data-id="element-4442" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-4443">
                Local business employee phones
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-4444">
              Get direct dial and mobile numbers for local business contacts.
            </p>
            <div data-id="element-4445">
              <div className="flex items-baseline gap-2" data-id="element-4446">
                <span className="text-4xl font-bold text-slate-900" data-id="element-4447">$24</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-4448">
                per 100 phones found
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 mb-16" data-id="element-4449">
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-4450">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-4451" />
            <span data-id="element-4452">Pay only for valid matches</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-4453">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-4454" />
            <span data-id="element-4455">Free credits to start</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-4456">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-4457" />
            <span data-id="element-4458">No credit card required</span>
          </div>
        </div>

        <div className="text-center" data-id="element-4459">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4" data-id="element-4460">
            <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-4 text-white font-bold bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors text-lg" data-id="element-4461">
              Try for free
            </a>
          </div>
        </div>
      </div>
    </section>;
}